import axios from 'axios';

// focas-hero proxy client (CONTRACT v2 §6). machine-sim proxies the real FOCAS adapter
// server-side so the browser stays same-origin. Both calls throw on 503 when focas-hero
// is unreachable (e.g. local dev without it) — callers should catch and show "unreachable".
const API_BASE = '/machinesim/api/focas-hero';

// [ { company, machine, port, host, identity:{cnc_type,mt_type,series,version,max_axis,paths} } ]
export const getFocasHeroInstances = async () => {
  const res = await axios.get(`${API_BASE}/instances`);
  return Array.isArray(res.data) ? res.data : [];
};

// { engine:{execution,faulted,cycle_progress,program,part_count,alarm_code,mapped},
//   macros:{}, params:{ "<no>":{value,dtype} }, tlm_macros:{ "<macro#>":number }, tlm_pmc:{ "<addr>":{value,width} } }
export const getFocasHeroValues = async (machine, company = 'default') => {
  const res = await axios.get(`${API_BASE}/${encodeURIComponent(machine)}/values`, { params: { company } });
  return res.data;
};
